<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
  mounted() {
    if (!localStorage.getItem("login")) {
      if (this.$route.path != "/login") {
        this.$router.push("/login");
      }
    }
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800&display=swap");

* {
  // font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-family: "Inter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html,
body {
  margin: 0;
}
.page {
  padding: 15px;
}
.page-header {
  position: fixed;
  background: #fff;
  top: 0;
  left: 0;
  padding: 15px 20px;
  width: calc(100% - 40px);
  margin: 0;
  margin-bottom: 20px;
  font-size: 15px;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  box-shadow: 0px 2px 3px #ddd;
  display: flex;
  align-items: center;
  gap: 15px;
}
button {
  background: #147bfe;
  border: 0;
  border-radius: 8px;
  color: #fff;
  width: 100%;
  padding: 15px;
  text-transform: uppercase;
  outline: none;
  transition: all 0.3s ease;
  font-weight: bold;

  &:active {
    background-color: #005bd3;
  }

  &:disabled {
    background-color: #69aaff;
  }
}

.lds-spinner {
  color: official;
  position: relative;
  width: 80px;
  height: 80px;
  margin: 50px auto;
}
.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 5px;
  height: 15px;
  border-radius: 20%;
  background: #999;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.mt {
  text-align: center;
  padding-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue